module.exports = __webpack_public_path__ + "static/media/sales-square.011518dc.jpg";